var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TM2U-Admin---Inclinic-5",
    transform: "translate(-1350.000000, -121.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-bar",
    transform: "translate(296.000000, 101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1054.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.90660947,8.91784802 C1.90660947,5.05156179 5.05187956,1.90660947 8.91784802,1.90660947 C12.7838165,1.90660947 15.9290866,5.05156179 15.9290866,8.91784802 C15.9290866,10.7609038 15.2131547,12.4390379 14.0466275,13.6916804 C14.0291502,13.7066155 14.0104019,13.7180551 13.9941957,13.7345791 C13.967821,13.7609538 13.9478016,13.7905063 13.92524,13.8187877 C12.6516249,15.1200486 10.8778426,15.9290866 8.91784802,15.9290866 C5.05187956,15.9290866 1.90660947,12.7841343 1.90660947,8.91784802 M19.721015,18.1131077 L15.9723031,14.3643957 C17.1391481,12.8565854 17.835696,10.9674532 17.835696,8.91784802 C17.835696,4.00038443 13.8353116,0 8.91784802,0 C4.0007022,0 0,4.00038443 0,8.91784802 C0,13.8353116 4.0007022,17.835696 8.91784802,17.835696 C11.1002803,17.835696 13.1006314,17.0466775 14.6522938,15.74065 L18.3727244,19.4610806 C18.5589366,19.6472928 18.8029826,19.7403989 19.0467108,19.7403989 C19.2907568,19.7403989 19.5348028,19.6472928 19.721015,19.4610806 C20.0931217,19.088974 20.0931217,18.4852143 19.721015,18.1131077",
    id: "Fill-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.f5e95de19535e8a7c93d98b7b6fd568e.svg";
export { ForwardRef as ReactComponent };